var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-darker pt-5"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('hostel-search')],1),_c('div',{staticClass:"col-sm-8"},[_c('hostel-lists')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }